import React from "react";
import { Theme, StandardProps, IconButton } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import { StyleClassKey } from "js/react/typescript";
import { DirectoryBreadCrumbItem } from "js/react/scenes/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DirectoryItem } from "js/react/scenes/components/MediaManagement/Types";
import { ViewTypes } from "js/react/scenes/components/MediaManagement";

const styles = (theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
            flexWrap: "wrap",
            padding: theme.spacing(0),
            flexGrow: 1,
            borderBottom: `1px solid ${theme.palette.grey["300"]}`
        },
        viewIcon: {
            color: theme.palette.primary.main,
            padding: theme.spacing(0.5),
            margin: theme.spacing(0.5, 1),
            "& svg": {
                fontSize: "1rem"
            }
        }
    });

type DirectoryBreadCrumbsComponentClassKey = StyleClassKey<typeof styles>;

const useStyles = makeStyles(styles);
export interface DirectoryBreadCrumbsComponentProps
    extends StandardProps<{}, DirectoryBreadCrumbsComponentClassKey> {
    listings: DirectoryItem[];
    onUpdate: (listings: DirectoryItem[]) => void;
    onViewUpdate: (view: ViewTypes) => void;
    view: ViewTypes;
}

function Component(props: DirectoryBreadCrumbsComponentProps) {
    const classes = useStyles(props);
    const { listings, onUpdate, onViewUpdate, view } = props;

    const historyListings = listings;

    const items = historyListings.map((d, idx) => {
        return (
            <DirectoryBreadCrumbItem
                key={d.path}
                active={idx === historyListings.length - 1}
                directory={d}
                onClick={() => {
                    const newListings = listings.slice(0, idx + 1);
                    onUpdate(newListings);
                }}
                onDelete={() => {
                    const newListings = listings.filter(l => d.path !== l.path);
                    onUpdate(newListings);
                }}
            />
        );
    });
    return (
        <div className={classes.root}>
            {/*{view === ViewTypes.GRID && (
                <IconButton
                    onClick={() => onViewUpdate(ViewTypes.LIST)}
                    className={classes.viewIcon}
                >
                    <FontAwesomeIcon icon={["far", "bars"]} />
                </IconButton>
            )}
            {view === ViewTypes.LIST && (
                <IconButton
                    onClick={() => onViewUpdate(ViewTypes.GRID)}
                    className={classes.viewIcon}
                >
                    <FontAwesomeIcon icon={["fal", "border-all"]} />
                </IconButton>
            )}*/}
            {items}
        </div>
    );
}

Component.defaultProps = {} as DirectoryBreadCrumbsComponentProps;
Component.displayName = "DirectoryBreadCrumbsComponent";
export const DirectoryBreadCrumbsComponent = Component;
export default DirectoryBreadCrumbsComponent;
